import { tagsConstants } from '../_constants';
import * as commonAction from './commonAction';
import { tagsService, commonService } from '../_services';
import { alertActions } from '.';

export const tagsActions = {
    getTagsList,
    addUpdateTag,
    deleteTag,
    getTagDetails,
    addTag,
    getTagsAll
};

//-- getTagsList
function getTagsList(apiName,tagsData,) {
    
    return dispatch => {
        dispatch(commonAction.request(tagsConstants.TAGS_LIST_REQUEST, tagsData));
        tagsService.getTagsList(apiName, tagsData)
            .then(
                tags => {
                    
                    console.log("Successfully",tags.data);
                    dispatch(commonAction.success(tagsConstants.TAGS_LIST_SUCCESS, tags.data));
                    if (tags.success == false) {
                        dispatch(commonAction.failure(tagsConstants.TAGS_LIST_ERROR, tags.message));
                        dispatch(alertActions.error(tags.message));
                    } 
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}


//-- add/Update Terms data
function addUpdateTag(apiName, tagsData, apiNameListing, postDataForListing) {
    return dispatch => {
        dispatch(commonAction.request(tagsConstants.TAGS_LIST_REQUEST, tagsData));
        commonService.withToken(apiName, tagsData)
            .then(
                tags => {
                    setTimeout(function () {
                        dispatch(getTagsList(apiNameListing, postDataForListing));
                    }, 1000);

                    dispatch(commonAction.success(tagsConstants.TAGS_LIST_SUCCESS, tags));
                    dispatch(alertActions.success(tags.data.message));
                    if (tags.success == false) {
                        dispatch(commonAction.failure(tagsConstants.TAGS_LIST_ERROR, tags.message));
                        dispatch(alertActions.error(tags.message));
                    } 
                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}

//-- Delete Terms
function deleteTag(apiName, tagsData, apiNameListing, postDataForListing) {
    return dispatch => {
        dispatch(commonAction.request(tagsConstants.TAGS_DELETE_REQUEST, tagsData));
        commonService.withToken(apiName, tagsData)
            .then(
                tags => {
                    setTimeout(function () {
                        dispatch(getTagsList(apiNameListing, postDataForListing));
                    }, 1000);

                    dispatch(commonAction.success(tagsConstants.TAGS_DELETE_SUCCESS, tags));
                    dispatch(alertActions.success(tags.data.message));
                    if (tags.success == false) {
                        dispatch(commonAction.failure(tagsConstants.TAGS_DELETE_FAILURE, tags.message));
                        dispatch(alertActions.error(tags.message));
                    }
                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}


//-- Get tagss detail
function getTagDetails(apiName,tagsData) {
    return dispatch => {
        dispatch(commonAction.request(tagsConstants.TAGS_GET_PROFILE_REQUEST, tagsData));
        commonService.withToken(apiName, tagsData)
            .then(
                tags => {
                    //console.log("Successfully",tags.data);
                    dispatch(commonAction.success(tagsConstants.TAGS_GET_PROFILE_SUCCESS, tags.data));
                    if (tags.success == false) {
                        dispatch(commonAction.failure(tagsConstants.TAGS_GET_PROFILE_FAILURE, tags.message));
                        dispatch(alertActions.error(tags.message));
                    } 
                },
                error => {console.log("FAIL",error);
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}


function addTag(apiName,tagsData, apiNameListing, postDataForListing){
    return dispatch => {
        dispatch(commonAction.request(tagsConstants.TAGS_ADD_REQUEST, tagsData));
        commonService.withToken(apiName, tagsData)
            .then(
                tags => {   
                    
                    setTimeout(function () {
                        dispatch(getTagsList(apiNameListing, postDataForListing));
                    }, 1000);

                    dispatch(commonAction.success(tagsConstants.TAGS_ADD_SUCCESS, tags.data));
                    if (tags.success == false) {
                        dispatch(commonAction.failure(tagsConstants.TAGS_ADD_FAILURE, tags.message));
                        dispatch(alertActions.error(tags.message));
                    } 
                },
                error => {console.log("FAIL",error);
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}


function getTagsAll(apiName,tagsData){
    return dispatch => {
        dispatch(commonAction.request(tagsConstants.ACTIVE_TAGS_GET_REQUEST, tagsData));
        commonService.withToken(apiName, tagsData)
            .then(
                tags => {  

                    dispatch(commonAction.success(tagsConstants.ACTIVE_TAGS_GET_SUCCESS, tags.data));
                    if (tags.success == false) {
                        dispatch(commonAction.failure(tagsConstants.ACTIVE_TAGS_GET_FAILURE, tags.message));
                        dispatch(alertActions.error(tags.message));
                    } 
                },
                error => {console.log("FAIL",error);
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}